(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1442"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1442"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gNVT3", function(module, exports) {

$parcel$export(module.exports, "default", () => $03283a53036a3e91$export$2e2bcd8739ae039);
const baseUrl = document.currentScript?.getAttribute("data-base") ?? "/";
const searchJsonUrl = baseUrl + "search.json";
const pagefindUrl = baseUrl + "pagefind/pagefind.js";
function $03283a53036a3e91$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("search", ()=>({
            _notes$: null,
            _pagefind: null,
            open: false,
            term: "",
            results: null,
            selectedId: null,
            init () {
                this.$watch("term", async ()=>{
                    const results = await this.search();
                    if (results) {
                        this.results = results;
                        this.open = true;
                        this.selectedId = this.results[0]?.id ?? null;
                    }
                });
            },
            get selectedIdx () {
                return this.results.findIndex((r)=>r.id === this.selectedId);
            },
            selectPrevResult () {
                const newIdx = Math.max(0, this.selectedIdx - 1);
                this.selectedId = this.results[newIdx].id;
            },
            selectNextResult () {
                const newIdx = Math.min(this.results.length - 1, this.selectedIdx + 1);
                this.selectedId = this.results[newIdx].id;
            },
            onKeyDown (event) {
                switch(event.key){
                    case "Escape":
                        this.open = false;
                        break;
                    case "ArrowUp":
                        event.preventDefault();
                        this.results && this.selectPrevResult();
                        break;
                    case "ArrowDown":
                        event.preventDefault();
                        this.results && this.selectNextResult();
                        break;
                    case "Enter":
                        event.preventDefault();
                        const result = this.results?.[this.selectedIdx];
                        if (result) window.location.href = result.url;
                        break;
                }
            },
            async fetchNotes () {
                if (!this._notes) this._notes = new Promise(async (resolve)=>{
                    const result = await fetch(searchJsonUrl).then((r)=>r.json());
                    resolve(result.notes);
                });
                return this._notes;
            },
            async loadPagefind () {
                if (!this._pagefind) this._pagefind = new Promise(async (resolve)=>{
                    // Workaround, waiting for https://github.com/parcel-bundler/parcel/issues/8316
                    const pagefind = await eval(`import("${pagefindUrl}")`);
                    await pagefind.options({
                        excerptLength: 15
                    });
                    resolve(pagefind);
                });
                return this._pagefind;
            },
            async search () {
                const pagefind = await this.loadPagefind();
                const tagsQuery = this.term.match(/#(\S+)/g) ?? [];
                const tags = tagsQuery.map((tag)=>tag.substring(1));
                const termWithoutTags = this.term.replace(/#(\S+)/g, "").trim();
                const searchTerm = termWithoutTags || null;
                const filters = tags.length ? {
                    tags: tags
                } : undefined;
                const search = await pagefind.debouncedSearch(searchTerm, {
                    filters: filters
                });
                if (!search) return null;
                const results = await Promise.all(search.results.map((x)=>x.data()));
                return results.map((x)=>({
                        id: x.url,
                        url: x.url,
                        title: x.meta.title,
                        excerpt: x.excerpt
                    }));
            }
        }));
}

});

// packages/alpinejs/src/scheduler.js
var $eadc12ef91cf6554$var$flushPending = false;
var $eadc12ef91cf6554$var$flushing = false;
var $eadc12ef91cf6554$var$queue = [];
var $eadc12ef91cf6554$var$lastFlushedIndex = -1;
var $eadc12ef91cf6554$var$transactionActive = false;
function $eadc12ef91cf6554$var$scheduler(callback) {
    $eadc12ef91cf6554$var$queueJob(callback);
}
function $eadc12ef91cf6554$var$startTransaction() {
    $eadc12ef91cf6554$var$transactionActive = true;
}
function $eadc12ef91cf6554$var$commitTransaction() {
    $eadc12ef91cf6554$var$transactionActive = false;
    $eadc12ef91cf6554$var$queueFlush();
}
function $eadc12ef91cf6554$var$queueJob(job) {
    if (!$eadc12ef91cf6554$var$queue.includes(job)) $eadc12ef91cf6554$var$queue.push(job);
    $eadc12ef91cf6554$var$queueFlush();
}
function $eadc12ef91cf6554$var$dequeueJob(job) {
    let index = $eadc12ef91cf6554$var$queue.indexOf(job);
    if (index !== -1 && index > $eadc12ef91cf6554$var$lastFlushedIndex) $eadc12ef91cf6554$var$queue.splice(index, 1);
}
function $eadc12ef91cf6554$var$queueFlush() {
    if (!$eadc12ef91cf6554$var$flushing && !$eadc12ef91cf6554$var$flushPending) {
        if ($eadc12ef91cf6554$var$transactionActive) return;
        $eadc12ef91cf6554$var$flushPending = true;
        queueMicrotask($eadc12ef91cf6554$var$flushJobs);
    }
}
function $eadc12ef91cf6554$var$flushJobs() {
    $eadc12ef91cf6554$var$flushPending = false;
    $eadc12ef91cf6554$var$flushing = true;
    for(let i = 0; i < $eadc12ef91cf6554$var$queue.length; i++){
        $eadc12ef91cf6554$var$queue[i]();
        $eadc12ef91cf6554$var$lastFlushedIndex = i;
    }
    $eadc12ef91cf6554$var$queue.length = 0;
    $eadc12ef91cf6554$var$lastFlushedIndex = -1;
    $eadc12ef91cf6554$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $eadc12ef91cf6554$var$reactive;
var $eadc12ef91cf6554$var$effect;
var $eadc12ef91cf6554$var$release;
var $eadc12ef91cf6554$var$raw;
var $eadc12ef91cf6554$var$shouldSchedule = true;
function $eadc12ef91cf6554$var$disableEffectScheduling(callback) {
    $eadc12ef91cf6554$var$shouldSchedule = false;
    callback();
    $eadc12ef91cf6554$var$shouldSchedule = true;
}
function $eadc12ef91cf6554$var$setReactivityEngine(engine) {
    $eadc12ef91cf6554$var$reactive = engine.reactive;
    $eadc12ef91cf6554$var$release = engine.release;
    $eadc12ef91cf6554$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($eadc12ef91cf6554$var$shouldSchedule) $eadc12ef91cf6554$var$scheduler(task);
                else task();
            }
        });
    $eadc12ef91cf6554$var$raw = engine.raw;
}
function $eadc12ef91cf6554$var$overrideEffect(override) {
    $eadc12ef91cf6554$var$effect = override;
}
function $eadc12ef91cf6554$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $eadc12ef91cf6554$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $eadc12ef91cf6554$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $eadc12ef91cf6554$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $eadc12ef91cf6554$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) {
            if (typeof value === "object" || value !== oldValue) {
                let previousValue = oldValue;
                queueMicrotask(()=>{
                    callback(value, previousValue);
                });
            }
        }
        oldValue = value;
        firstTime = false;
    });
    return ()=>$eadc12ef91cf6554$var$release(effectReference);
}
async function $eadc12ef91cf6554$var$transaction(callback) {
    $eadc12ef91cf6554$var$startTransaction();
    try {
        await callback();
        await Promise.resolve();
    } finally{
        $eadc12ef91cf6554$var$commitTransaction();
    }
}
// packages/alpinejs/src/mutation.js
var $eadc12ef91cf6554$var$onAttributeAddeds = [];
var $eadc12ef91cf6554$var$onElRemoveds = [];
var $eadc12ef91cf6554$var$onElAddeds = [];
function $eadc12ef91cf6554$var$onElAdded(callback) {
    $eadc12ef91cf6554$var$onElAddeds.push(callback);
}
function $eadc12ef91cf6554$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $eadc12ef91cf6554$var$onElRemoveds.push(callback);
    }
}
function $eadc12ef91cf6554$var$onAttributesAdded(callback) {
    $eadc12ef91cf6554$var$onAttributeAddeds.push(callback);
}
function $eadc12ef91cf6554$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $eadc12ef91cf6554$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $eadc12ef91cf6554$var$cleanupElement(el) {
    el._x_effects?.forEach($eadc12ef91cf6554$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $eadc12ef91cf6554$var$observer = new MutationObserver($eadc12ef91cf6554$var$onMutate);
var $eadc12ef91cf6554$var$currentlyObserving = false;
function $eadc12ef91cf6554$var$startObservingMutations() {
    $eadc12ef91cf6554$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $eadc12ef91cf6554$var$currentlyObserving = true;
}
function $eadc12ef91cf6554$var$stopObservingMutations() {
    $eadc12ef91cf6554$var$flushObserver();
    $eadc12ef91cf6554$var$observer.disconnect();
    $eadc12ef91cf6554$var$currentlyObserving = false;
}
var $eadc12ef91cf6554$var$queuedMutations = [];
function $eadc12ef91cf6554$var$flushObserver() {
    let records = $eadc12ef91cf6554$var$observer.takeRecords();
    $eadc12ef91cf6554$var$queuedMutations.push(()=>records.length > 0 && $eadc12ef91cf6554$var$onMutate(records));
    let queueLengthWhenTriggered = $eadc12ef91cf6554$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($eadc12ef91cf6554$var$queuedMutations.length === queueLengthWhenTriggered) while($eadc12ef91cf6554$var$queuedMutations.length > 0)$eadc12ef91cf6554$var$queuedMutations.shift()();
    });
}
function $eadc12ef91cf6554$var$mutateDom(callback) {
    if (!$eadc12ef91cf6554$var$currentlyObserving) return callback();
    $eadc12ef91cf6554$var$stopObservingMutations();
    let result = callback();
    $eadc12ef91cf6554$var$startObservingMutations();
    return result;
}
var $eadc12ef91cf6554$var$isCollecting = false;
var $eadc12ef91cf6554$var$deferredMutations = [];
function $eadc12ef91cf6554$var$deferMutations() {
    $eadc12ef91cf6554$var$isCollecting = true;
}
function $eadc12ef91cf6554$var$flushAndStopDeferringMutations() {
    $eadc12ef91cf6554$var$isCollecting = false;
    $eadc12ef91cf6554$var$onMutate($eadc12ef91cf6554$var$deferredMutations);
    $eadc12ef91cf6554$var$deferredMutations = [];
}
function $eadc12ef91cf6554$var$onMutate(mutations) {
    if ($eadc12ef91cf6554$var$isCollecting) {
        $eadc12ef91cf6554$var$deferredMutations = $eadc12ef91cf6554$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $eadc12ef91cf6554$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $eadc12ef91cf6554$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $eadc12ef91cf6554$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $eadc12ef91cf6554$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $eadc12ef91cf6554$var$scope(node) {
    return $eadc12ef91cf6554$var$mergeProxies($eadc12ef91cf6554$var$closestDataStack(node));
}
function $eadc12ef91cf6554$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$eadc12ef91cf6554$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $eadc12ef91cf6554$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $eadc12ef91cf6554$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $eadc12ef91cf6554$var$closestDataStack(node.parentNode);
}
function $eadc12ef91cf6554$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $eadc12ef91cf6554$var$mergeProxyTrap);
}
var $eadc12ef91cf6554$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $eadc12ef91cf6554$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $eadc12ef91cf6554$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $eadc12ef91cf6554$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $eadc12ef91cf6554$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$eadc12ef91cf6554$var$get(data2, path), (value)=>$eadc12ef91cf6554$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $eadc12ef91cf6554$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $eadc12ef91cf6554$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $eadc12ef91cf6554$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $eadc12ef91cf6554$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $eadc12ef91cf6554$var$magics = {};
function $eadc12ef91cf6554$var$magic(name, callback) {
    $eadc12ef91cf6554$var$magics[name] = callback;
}
function $eadc12ef91cf6554$var$injectMagics(obj, el) {
    let memoizedUtilities = $eadc12ef91cf6554$var$getUtilities(el);
    Object.entries($eadc12ef91cf6554$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $eadc12ef91cf6554$var$getUtilities(el) {
    let [utilities, cleanup2] = $eadc12ef91cf6554$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $eadc12ef91cf6554$var$interceptor,
        ...utilities
    };
    $eadc12ef91cf6554$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $eadc12ef91cf6554$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $eadc12ef91cf6554$var$handleError(e, el, expression);
    }
}
function $eadc12ef91cf6554$var$handleError(...args) {
    return $eadc12ef91cf6554$var$errorHandler(...args);
}
var $eadc12ef91cf6554$var$errorHandler = $eadc12ef91cf6554$var$normalErrorHandler;
function $eadc12ef91cf6554$var$setErrorHandler(handler4) {
    $eadc12ef91cf6554$var$errorHandler = handler4;
}
function $eadc12ef91cf6554$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $eadc12ef91cf6554$var$shouldAutoEvaluateFunctions = true;
function $eadc12ef91cf6554$var$dontAutoEvaluateFunctions(callback) {
    let cache = $eadc12ef91cf6554$var$shouldAutoEvaluateFunctions;
    $eadc12ef91cf6554$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $eadc12ef91cf6554$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $eadc12ef91cf6554$var$evaluate(el, expression, extras = {}) {
    let result;
    $eadc12ef91cf6554$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $eadc12ef91cf6554$var$evaluateLater(...args) {
    return $eadc12ef91cf6554$var$theEvaluatorFunction(...args);
}
var $eadc12ef91cf6554$var$theEvaluatorFunction = $eadc12ef91cf6554$var$normalEvaluator;
function $eadc12ef91cf6554$var$setEvaluator(newEvaluator) {
    $eadc12ef91cf6554$var$theEvaluatorFunction = newEvaluator;
}
var $eadc12ef91cf6554$var$theRawEvaluatorFunction;
function $eadc12ef91cf6554$var$setRawEvaluator(newEvaluator) {
    $eadc12ef91cf6554$var$theRawEvaluatorFunction = newEvaluator;
}
function $eadc12ef91cf6554$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $eadc12ef91cf6554$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$eadc12ef91cf6554$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $eadc12ef91cf6554$var$generateEvaluatorFromFunction(dataStack, expression) : $eadc12ef91cf6554$var$generateEvaluatorFromString(dataStack, expression, el);
    return $eadc12ef91cf6554$var$tryCatch.bind(null, el, expression, evaluator);
}
function $eadc12ef91cf6554$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        if (!$eadc12ef91cf6554$var$shouldAutoEvaluateFunctions) {
            $eadc12ef91cf6554$var$runIfTypeOfFunction(receiver, func, $eadc12ef91cf6554$var$mergeProxies([
                scope2,
                ...dataStack
            ]), params);
            return;
        }
        let result = func.apply($eadc12ef91cf6554$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $eadc12ef91cf6554$var$runIfTypeOfFunction(receiver, result);
    };
}
var $eadc12ef91cf6554$var$evaluatorMemo = {};
function $eadc12ef91cf6554$var$generateFunctionFromString(expression, el) {
    if ($eadc12ef91cf6554$var$evaluatorMemo[expression]) return $eadc12ef91cf6554$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $eadc12ef91cf6554$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $eadc12ef91cf6554$var$evaluatorMemo[expression] = func;
    return func;
}
function $eadc12ef91cf6554$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $eadc12ef91cf6554$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $eadc12ef91cf6554$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$eadc12ef91cf6554$var$handleError(error2, el, expression));
            if (func.finished) {
                $eadc12ef91cf6554$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $eadc12ef91cf6554$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$eadc12ef91cf6554$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $eadc12ef91cf6554$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($eadc12ef91cf6554$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$eadc12ef91cf6554$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$eadc12ef91cf6554$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
function $eadc12ef91cf6554$var$evaluateRaw(...args) {
    return $eadc12ef91cf6554$var$theRawEvaluatorFunction(...args);
}
function $eadc12ef91cf6554$var$normalRawEvaluator(el, expression, extras = {}) {
    let overriddenMagics = {};
    $eadc12ef91cf6554$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$eadc12ef91cf6554$var$closestDataStack(el)
    ];
    let scope2 = $eadc12ef91cf6554$var$mergeProxies([
        extras.scope ?? {},
        ...dataStack
    ]);
    let params = extras.params ?? [];
    if (expression.includes("await")) {
        let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
        let func = new AsyncFunction([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        return result;
    } else {
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(()=>{ ${expression} })()` : expression;
        let func = new Function([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        if (typeof result === "function" && $eadc12ef91cf6554$var$shouldAutoEvaluateFunctions) return result.apply(scope2, params);
        return result;
    }
}
// packages/alpinejs/src/directives.js
var $eadc12ef91cf6554$var$prefixAsString = "x-";
function $eadc12ef91cf6554$var$prefix(subject = "") {
    return $eadc12ef91cf6554$var$prefixAsString + subject;
}
function $eadc12ef91cf6554$var$setPrefix(newPrefix) {
    $eadc12ef91cf6554$var$prefixAsString = newPrefix;
}
var $eadc12ef91cf6554$var$directiveHandlers = {};
function $eadc12ef91cf6554$var$directive(name, callback) {
    $eadc12ef91cf6554$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$eadc12ef91cf6554$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $eadc12ef91cf6554$var$directiveOrder.indexOf(directive2);
            $eadc12ef91cf6554$var$directiveOrder.splice(pos >= 0 ? pos : $eadc12ef91cf6554$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $eadc12ef91cf6554$var$directiveExists(name) {
    return Object.keys($eadc12ef91cf6554$var$directiveHandlers).includes(name);
}
function $eadc12ef91cf6554$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $eadc12ef91cf6554$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($eadc12ef91cf6554$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($eadc12ef91cf6554$var$outNonAlpineAttributes).map($eadc12ef91cf6554$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($eadc12ef91cf6554$var$byPriority);
    return directives2.map((directive2)=>{
        return $eadc12ef91cf6554$var$getDirectiveHandler(el, directive2);
    });
}
function $eadc12ef91cf6554$var$attributesOnly(attributes) {
    return Array.from(attributes).map($eadc12ef91cf6554$var$toTransformedAttributes()).filter((attr)=>!$eadc12ef91cf6554$var$outNonAlpineAttributes(attr));
}
var $eadc12ef91cf6554$var$isDeferringHandlers = false;
var $eadc12ef91cf6554$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $eadc12ef91cf6554$var$currentHandlerStackKey = Symbol();
function $eadc12ef91cf6554$var$deferHandlingDirectives(callback) {
    $eadc12ef91cf6554$var$isDeferringHandlers = true;
    let key = Symbol();
    $eadc12ef91cf6554$var$currentHandlerStackKey = key;
    $eadc12ef91cf6554$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($eadc12ef91cf6554$var$directiveHandlerStacks.get(key).length)$eadc12ef91cf6554$var$directiveHandlerStacks.get(key).shift()();
        $eadc12ef91cf6554$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $eadc12ef91cf6554$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $eadc12ef91cf6554$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $eadc12ef91cf6554$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $eadc12ef91cf6554$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $eadc12ef91cf6554$var$evaluateLater.bind($eadc12ef91cf6554$var$evaluateLater, el),
        evaluate: $eadc12ef91cf6554$var$evaluate.bind($eadc12ef91cf6554$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $eadc12ef91cf6554$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $eadc12ef91cf6554$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $eadc12ef91cf6554$var$getElementBoundUtilities(el);
    $eadc12ef91cf6554$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $eadc12ef91cf6554$var$isDeferringHandlers ? $eadc12ef91cf6554$var$directiveHandlerStacks.get($eadc12ef91cf6554$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $eadc12ef91cf6554$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $eadc12ef91cf6554$var$into = (i)=>i;
function $eadc12ef91cf6554$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $eadc12ef91cf6554$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $eadc12ef91cf6554$var$attributeTransformers = [];
function $eadc12ef91cf6554$var$mapAttributes(callback) {
    $eadc12ef91cf6554$var$attributeTransformers.push(callback);
}
function $eadc12ef91cf6554$var$outNonAlpineAttributes({ name: name }) {
    return $eadc12ef91cf6554$var$alpineAttributeRegex().test(name);
}
var $eadc12ef91cf6554$var$alpineAttributeRegex = ()=>new RegExp(`^${$eadc12ef91cf6554$var$prefixAsString}([^:^.]+)\\b`);
function $eadc12ef91cf6554$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        if (name === value) value = "";
        let typeMatch = name.match($eadc12ef91cf6554$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $eadc12ef91cf6554$var$DEFAULT = "DEFAULT";
var $eadc12ef91cf6554$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $eadc12ef91cf6554$var$DEFAULT,
    "teleport"
];
function $eadc12ef91cf6554$var$byPriority(a, b) {
    let typeA = $eadc12ef91cf6554$var$directiveOrder.indexOf(a.type) === -1 ? $eadc12ef91cf6554$var$DEFAULT : a.type;
    let typeB = $eadc12ef91cf6554$var$directiveOrder.indexOf(b.type) === -1 ? $eadc12ef91cf6554$var$DEFAULT : b.type;
    return $eadc12ef91cf6554$var$directiveOrder.indexOf(typeA) - $eadc12ef91cf6554$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $eadc12ef91cf6554$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $eadc12ef91cf6554$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$eadc12ef91cf6554$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $eadc12ef91cf6554$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $eadc12ef91cf6554$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $eadc12ef91cf6554$var$started = false;
function $eadc12ef91cf6554$var$start() {
    if ($eadc12ef91cf6554$var$started) $eadc12ef91cf6554$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $eadc12ef91cf6554$var$started = true;
    if (!document.body) $eadc12ef91cf6554$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $eadc12ef91cf6554$var$dispatch(document, "alpine:init");
    $eadc12ef91cf6554$var$dispatch(document, "alpine:initializing");
    $eadc12ef91cf6554$var$startObservingMutations();
    $eadc12ef91cf6554$var$onElAdded((el)=>$eadc12ef91cf6554$var$initTree(el, $eadc12ef91cf6554$var$walk));
    $eadc12ef91cf6554$var$onElRemoved((el)=>$eadc12ef91cf6554$var$destroyTree(el));
    $eadc12ef91cf6554$var$onAttributesAdded((el, attrs)=>{
        $eadc12ef91cf6554$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$eadc12ef91cf6554$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($eadc12ef91cf6554$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $eadc12ef91cf6554$var$initTree(el);
    });
    $eadc12ef91cf6554$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $eadc12ef91cf6554$var$warnAboutMissingPlugins();
    });
}
var $eadc12ef91cf6554$var$rootSelectorCallbacks = [];
var $eadc12ef91cf6554$var$initSelectorCallbacks = [];
function $eadc12ef91cf6554$var$rootSelectors() {
    return $eadc12ef91cf6554$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $eadc12ef91cf6554$var$allSelectors() {
    return $eadc12ef91cf6554$var$rootSelectorCallbacks.concat($eadc12ef91cf6554$var$initSelectorCallbacks).map((fn)=>fn());
}
function $eadc12ef91cf6554$var$addRootSelector(selectorCallback) {
    $eadc12ef91cf6554$var$rootSelectorCallbacks.push(selectorCallback);
}
function $eadc12ef91cf6554$var$addInitSelector(selectorCallback) {
    $eadc12ef91cf6554$var$initSelectorCallbacks.push(selectorCallback);
}
function $eadc12ef91cf6554$var$closestRoot(el, includeInitSelectors = false) {
    return $eadc12ef91cf6554$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $eadc12ef91cf6554$var$allSelectors() : $eadc12ef91cf6554$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $eadc12ef91cf6554$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (el.parentNode instanceof ShadowRoot) return $eadc12ef91cf6554$var$findClosest(el.parentNode.host, callback);
    if (!el.parentElement) return;
    return $eadc12ef91cf6554$var$findClosest(el.parentElement, callback);
}
function $eadc12ef91cf6554$var$isRoot(el) {
    return $eadc12ef91cf6554$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $eadc12ef91cf6554$var$initInterceptors2 = [];
function $eadc12ef91cf6554$var$interceptInit(callback) {
    $eadc12ef91cf6554$var$initInterceptors2.push(callback);
}
var $eadc12ef91cf6554$var$markerDispenser = 1;
function $eadc12ef91cf6554$var$initTree(el, walker = $eadc12ef91cf6554$var$walk, intercept = ()=>{}) {
    if ($eadc12ef91cf6554$var$findClosest(el, (i)=>i._x_ignore)) return;
    $eadc12ef91cf6554$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $eadc12ef91cf6554$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $eadc12ef91cf6554$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $eadc12ef91cf6554$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $eadc12ef91cf6554$var$destroyTree(root, walker = $eadc12ef91cf6554$var$walk) {
    walker(root, (el)=>{
        $eadc12ef91cf6554$var$cleanupElement(el);
        $eadc12ef91cf6554$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $eadc12ef91cf6554$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($eadc12ef91cf6554$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $eadc12ef91cf6554$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $eadc12ef91cf6554$var$tickStack = [];
var $eadc12ef91cf6554$var$isHolding = false;
function $eadc12ef91cf6554$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $eadc12ef91cf6554$var$isHolding || setTimeout(()=>{
            $eadc12ef91cf6554$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $eadc12ef91cf6554$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $eadc12ef91cf6554$var$releaseNextTicks() {
    $eadc12ef91cf6554$var$isHolding = false;
    while($eadc12ef91cf6554$var$tickStack.length)$eadc12ef91cf6554$var$tickStack.shift()();
}
function $eadc12ef91cf6554$var$holdNextTicks() {
    $eadc12ef91cf6554$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $eadc12ef91cf6554$var$setClasses(el, value) {
    if (Array.isArray(value)) return $eadc12ef91cf6554$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $eadc12ef91cf6554$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $eadc12ef91cf6554$var$setClasses(el, value());
    return $eadc12ef91cf6554$var$setClassesFromString(el, value);
}
function $eadc12ef91cf6554$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $eadc12ef91cf6554$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $eadc12ef91cf6554$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $eadc12ef91cf6554$var$setStylesFromObject(el, value);
    return $eadc12ef91cf6554$var$setStylesFromString(el, value);
}
function $eadc12ef91cf6554$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $eadc12ef91cf6554$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $eadc12ef91cf6554$var$setStyles(el, previousStyles);
    };
}
function $eadc12ef91cf6554$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $eadc12ef91cf6554$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $eadc12ef91cf6554$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$eadc12ef91cf6554$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $eadc12ef91cf6554$var$registerTransitionsFromHelper(el, modifiers, value);
    else $eadc12ef91cf6554$var$registerTransitionsFromClassString(el, expression, value);
});
function $eadc12ef91cf6554$var$registerTransitionsFromClassString(el, classString, stage) {
    $eadc12ef91cf6554$var$registerTransitionObject(el, $eadc12ef91cf6554$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $eadc12ef91cf6554$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $eadc12ef91cf6554$var$registerTransitionObject(el, $eadc12ef91cf6554$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $eadc12ef91cf6554$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $eadc12ef91cf6554$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $eadc12ef91cf6554$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $eadc12ef91cf6554$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $eadc12ef91cf6554$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $eadc12ef91cf6554$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $eadc12ef91cf6554$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $eadc12ef91cf6554$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $eadc12ef91cf6554$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $eadc12ef91cf6554$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $eadc12ef91cf6554$var$closestHide(parent);
}
function $eadc12ef91cf6554$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $eadc12ef91cf6554$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $eadc12ef91cf6554$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $eadc12ef91cf6554$var$once(()=>{
        $eadc12ef91cf6554$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $eadc12ef91cf6554$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $eadc12ef91cf6554$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $eadc12ef91cf6554$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $eadc12ef91cf6554$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $eadc12ef91cf6554$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $eadc12ef91cf6554$var$mutateDom(()=>{
                stages.end();
            });
            $eadc12ef91cf6554$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $eadc12ef91cf6554$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $eadc12ef91cf6554$var$isCloning = false;
function $eadc12ef91cf6554$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$eadc12ef91cf6554$var$isCloning ? fallback(...args) : callback(...args);
}
function $eadc12ef91cf6554$var$onlyDuringClone(callback) {
    return (...args)=>$eadc12ef91cf6554$var$isCloning && callback(...args);
}
var $eadc12ef91cf6554$var$interceptors = [];
function $eadc12ef91cf6554$var$interceptClone(callback) {
    $eadc12ef91cf6554$var$interceptors.push(callback);
}
function $eadc12ef91cf6554$var$cloneNode(from, to) {
    $eadc12ef91cf6554$var$interceptors.forEach((i)=>i(from, to));
    $eadc12ef91cf6554$var$isCloning = true;
    $eadc12ef91cf6554$var$dontRegisterReactiveSideEffects(()=>{
        $eadc12ef91cf6554$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $eadc12ef91cf6554$var$isCloning = false;
}
var $eadc12ef91cf6554$var$isCloningLegacy = false;
function $eadc12ef91cf6554$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $eadc12ef91cf6554$var$isCloning = true;
    $eadc12ef91cf6554$var$isCloningLegacy = true;
    $eadc12ef91cf6554$var$dontRegisterReactiveSideEffects(()=>{
        $eadc12ef91cf6554$var$cloneTree(newEl);
    });
    $eadc12ef91cf6554$var$isCloning = false;
    $eadc12ef91cf6554$var$isCloningLegacy = false;
}
function $eadc12ef91cf6554$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $eadc12ef91cf6554$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $eadc12ef91cf6554$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $eadc12ef91cf6554$var$initTree(el, shallowWalker);
}
function $eadc12ef91cf6554$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $eadc12ef91cf6554$var$effect;
    $eadc12ef91cf6554$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $eadc12ef91cf6554$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $eadc12ef91cf6554$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $eadc12ef91cf6554$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $eadc12ef91cf6554$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $eadc12ef91cf6554$var$camelCase(name) : name;
    switch(name){
        case "value":
            $eadc12ef91cf6554$var$bindInputValue(el, value);
            break;
        case "style":
            $eadc12ef91cf6554$var$bindStyles(el, value);
            break;
        case "class":
            $eadc12ef91cf6554$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $eadc12ef91cf6554$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $eadc12ef91cf6554$var$bindAttribute(el, name, value);
            break;
    }
}
function $eadc12ef91cf6554$var$bindInputValue(el, value) {
    if ($eadc12ef91cf6554$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $eadc12ef91cf6554$var$safeParseBoolean(el.value) === value;
            else el.checked = $eadc12ef91cf6554$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($eadc12ef91cf6554$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$eadc12ef91cf6554$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $eadc12ef91cf6554$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $eadc12ef91cf6554$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $eadc12ef91cf6554$var$setClasses(el, value);
}
function $eadc12ef91cf6554$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $eadc12ef91cf6554$var$setStyles(el, value);
}
function $eadc12ef91cf6554$var$bindAttributeAndProperty(el, name, value) {
    $eadc12ef91cf6554$var$bindAttribute(el, name, value);
    $eadc12ef91cf6554$var$setPropertyIfChanged(el, name, value);
}
function $eadc12ef91cf6554$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $eadc12ef91cf6554$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($eadc12ef91cf6554$var$isBooleanAttr(name)) value = name;
        $eadc12ef91cf6554$var$setIfChanged(el, name, value);
    }
}
function $eadc12ef91cf6554$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $eadc12ef91cf6554$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $eadc12ef91cf6554$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $eadc12ef91cf6554$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $eadc12ef91cf6554$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $eadc12ef91cf6554$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $eadc12ef91cf6554$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $eadc12ef91cf6554$var$isBooleanAttr(attrName) {
    return $eadc12ef91cf6554$var$booleanAttributes.has(attrName);
}
function $eadc12ef91cf6554$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $eadc12ef91cf6554$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $eadc12ef91cf6554$var$getAttributeBinding(el, name, fallback);
}
function $eadc12ef91cf6554$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $eadc12ef91cf6554$var$dontAutoEvaluateFunctions(()=>{
            return $eadc12ef91cf6554$var$evaluate(el, binding.expression);
        });
    }
    return $eadc12ef91cf6554$var$getAttributeBinding(el, name, fallback);
}
function $eadc12ef91cf6554$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($eadc12ef91cf6554$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $eadc12ef91cf6554$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $eadc12ef91cf6554$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $eadc12ef91cf6554$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $eadc12ef91cf6554$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $eadc12ef91cf6554$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $eadc12ef91cf6554$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($eadc12ef91cf6554$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($eadc12ef91cf6554$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($eadc12ef91cf6554$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $eadc12ef91cf6554$var$release(reference);
    };
}
function $eadc12ef91cf6554$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $eadc12ef91cf6554$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($eadc12ef91cf6554$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $eadc12ef91cf6554$var$stores = {};
var $eadc12ef91cf6554$var$isReactive = false;
function $eadc12ef91cf6554$var$store(name, value) {
    if (!$eadc12ef91cf6554$var$isReactive) {
        $eadc12ef91cf6554$var$stores = $eadc12ef91cf6554$var$reactive($eadc12ef91cf6554$var$stores);
        $eadc12ef91cf6554$var$isReactive = true;
    }
    if (value === void 0) return $eadc12ef91cf6554$var$stores[name];
    $eadc12ef91cf6554$var$stores[name] = value;
    $eadc12ef91cf6554$var$initInterceptors($eadc12ef91cf6554$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $eadc12ef91cf6554$var$stores[name].init();
}
function $eadc12ef91cf6554$var$getStores() {
    return $eadc12ef91cf6554$var$stores;
}
// packages/alpinejs/src/binds.js
var $eadc12ef91cf6554$var$binds = {};
function $eadc12ef91cf6554$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $eadc12ef91cf6554$var$applyBindingsObject(name, getBindings());
    else $eadc12ef91cf6554$var$binds[name] = getBindings;
    return ()=>{};
}
function $eadc12ef91cf6554$var$injectBindingProviders(obj) {
    Object.entries($eadc12ef91cf6554$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $eadc12ef91cf6554$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $eadc12ef91cf6554$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $eadc12ef91cf6554$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $eadc12ef91cf6554$var$datas = {};
function $eadc12ef91cf6554$var$data(name, callback) {
    $eadc12ef91cf6554$var$datas[name] = callback;
}
function $eadc12ef91cf6554$var$injectDataProviders(obj, context) {
    Object.entries($eadc12ef91cf6554$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $eadc12ef91cf6554$var$Alpine = {
    get reactive () {
        return $eadc12ef91cf6554$var$reactive;
    },
    get release () {
        return $eadc12ef91cf6554$var$release;
    },
    get effect () {
        return $eadc12ef91cf6554$var$effect;
    },
    get raw () {
        return $eadc12ef91cf6554$var$raw;
    },
    get transaction () {
        return $eadc12ef91cf6554$var$transaction;
    },
    version: "3.15.8",
    flushAndStopDeferringMutations: $eadc12ef91cf6554$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $eadc12ef91cf6554$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $eadc12ef91cf6554$var$disableEffectScheduling,
    startObservingMutations: $eadc12ef91cf6554$var$startObservingMutations,
    stopObservingMutations: $eadc12ef91cf6554$var$stopObservingMutations,
    setReactivityEngine: $eadc12ef91cf6554$var$setReactivityEngine,
    onAttributeRemoved: $eadc12ef91cf6554$var$onAttributeRemoved,
    onAttributesAdded: $eadc12ef91cf6554$var$onAttributesAdded,
    closestDataStack: $eadc12ef91cf6554$var$closestDataStack,
    skipDuringClone: $eadc12ef91cf6554$var$skipDuringClone,
    onlyDuringClone: $eadc12ef91cf6554$var$onlyDuringClone,
    addRootSelector: $eadc12ef91cf6554$var$addRootSelector,
    addInitSelector: $eadc12ef91cf6554$var$addInitSelector,
    setErrorHandler: $eadc12ef91cf6554$var$setErrorHandler,
    interceptClone: $eadc12ef91cf6554$var$interceptClone,
    addScopeToNode: $eadc12ef91cf6554$var$addScopeToNode,
    deferMutations: $eadc12ef91cf6554$var$deferMutations,
    mapAttributes: $eadc12ef91cf6554$var$mapAttributes,
    evaluateLater: $eadc12ef91cf6554$var$evaluateLater,
    interceptInit: $eadc12ef91cf6554$var$interceptInit,
    initInterceptors: $eadc12ef91cf6554$var$initInterceptors,
    injectMagics: $eadc12ef91cf6554$var$injectMagics,
    setEvaluator: $eadc12ef91cf6554$var$setEvaluator,
    setRawEvaluator: $eadc12ef91cf6554$var$setRawEvaluator,
    mergeProxies: $eadc12ef91cf6554$var$mergeProxies,
    extractProp: $eadc12ef91cf6554$var$extractProp,
    findClosest: $eadc12ef91cf6554$var$findClosest,
    onElRemoved: $eadc12ef91cf6554$var$onElRemoved,
    closestRoot: $eadc12ef91cf6554$var$closestRoot,
    destroyTree: $eadc12ef91cf6554$var$destroyTree,
    interceptor: $eadc12ef91cf6554$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $eadc12ef91cf6554$var$transition,
    setStyles: // INTERNAL
    $eadc12ef91cf6554$var$setStyles,
    mutateDom: // INTERNAL
    $eadc12ef91cf6554$var$mutateDom,
    directive: $eadc12ef91cf6554$var$directive,
    entangle: $eadc12ef91cf6554$var$entangle,
    throttle: $eadc12ef91cf6554$var$throttle,
    debounce: $eadc12ef91cf6554$var$debounce,
    evaluate: $eadc12ef91cf6554$var$evaluate,
    evaluateRaw: $eadc12ef91cf6554$var$evaluateRaw,
    initTree: $eadc12ef91cf6554$var$initTree,
    nextTick: $eadc12ef91cf6554$var$nextTick,
    prefixed: $eadc12ef91cf6554$var$prefix,
    prefix: $eadc12ef91cf6554$var$setPrefix,
    plugin: $eadc12ef91cf6554$var$plugin,
    magic: $eadc12ef91cf6554$var$magic,
    store: $eadc12ef91cf6554$var$store,
    start: $eadc12ef91cf6554$var$start,
    clone: $eadc12ef91cf6554$var$clone,
    cloneNode: // INTERNAL
    $eadc12ef91cf6554$var$cloneNode,
    // INTERNAL
    bound: $eadc12ef91cf6554$var$getBinding,
    $data: $eadc12ef91cf6554$var$scope,
    watch: $eadc12ef91cf6554$var$watch,
    walk: $eadc12ef91cf6554$var$walk,
    data: $eadc12ef91cf6554$var$data,
    bind: $eadc12ef91cf6554$var$bind2
};
var $eadc12ef91cf6554$var$alpine_default = $eadc12ef91cf6554$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $eadc12ef91cf6554$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $eadc12ef91cf6554$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $eadc12ef91cf6554$var$isBooleanAttr2 = /* @__PURE__ */ $eadc12ef91cf6554$var$makeMap($eadc12ef91cf6554$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $eadc12ef91cf6554$var$EMPTY_OBJ = Object.freeze({});
var $eadc12ef91cf6554$var$EMPTY_ARR = Object.freeze([]);
var $eadc12ef91cf6554$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $eadc12ef91cf6554$var$hasOwn = (val, key)=>$eadc12ef91cf6554$var$hasOwnProperty.call(val, key);
var $eadc12ef91cf6554$var$isArray = Array.isArray;
var $eadc12ef91cf6554$var$isMap = (val)=>$eadc12ef91cf6554$var$toTypeString(val) === "[object Map]";
var $eadc12ef91cf6554$var$isString = (val)=>typeof val === "string";
var $eadc12ef91cf6554$var$isSymbol = (val)=>typeof val === "symbol";
var $eadc12ef91cf6554$var$isObject = (val)=>val !== null && typeof val === "object";
var $eadc12ef91cf6554$var$objectToString = Object.prototype.toString;
var $eadc12ef91cf6554$var$toTypeString = (value)=>$eadc12ef91cf6554$var$objectToString.call(value);
var $eadc12ef91cf6554$var$toRawType = (value)=>{
    return $eadc12ef91cf6554$var$toTypeString(value).slice(8, -1);
};
var $eadc12ef91cf6554$var$isIntegerKey = (key)=>$eadc12ef91cf6554$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $eadc12ef91cf6554$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $eadc12ef91cf6554$var$camelizeRE = /-(\w)/g;
var $eadc12ef91cf6554$var$camelize = $eadc12ef91cf6554$var$cacheStringFunction((str)=>{
    return str.replace($eadc12ef91cf6554$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $eadc12ef91cf6554$var$hyphenateRE = /\B([A-Z])/g;
var $eadc12ef91cf6554$var$hyphenate = $eadc12ef91cf6554$var$cacheStringFunction((str)=>str.replace($eadc12ef91cf6554$var$hyphenateRE, "-$1").toLowerCase());
var $eadc12ef91cf6554$var$capitalize = $eadc12ef91cf6554$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $eadc12ef91cf6554$var$toHandlerKey = $eadc12ef91cf6554$var$cacheStringFunction((str)=>str ? `on${$eadc12ef91cf6554$var$capitalize(str)}` : ``);
var $eadc12ef91cf6554$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $eadc12ef91cf6554$var$targetMap = /* @__PURE__ */ new WeakMap();
var $eadc12ef91cf6554$var$effectStack = [];
var $eadc12ef91cf6554$var$activeEffect;
var $eadc12ef91cf6554$var$ITERATE_KEY = Symbol("iterate");
var $eadc12ef91cf6554$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $eadc12ef91cf6554$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $eadc12ef91cf6554$var$effect2(fn, options = $eadc12ef91cf6554$var$EMPTY_OBJ) {
    if ($eadc12ef91cf6554$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $eadc12ef91cf6554$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $eadc12ef91cf6554$var$stop(effect3) {
    if (effect3.active) {
        $eadc12ef91cf6554$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $eadc12ef91cf6554$var$uid = 0;
function $eadc12ef91cf6554$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$eadc12ef91cf6554$var$effectStack.includes(effect3)) {
            $eadc12ef91cf6554$var$cleanup(effect3);
            try {
                $eadc12ef91cf6554$var$enableTracking();
                $eadc12ef91cf6554$var$effectStack.push(effect3);
                $eadc12ef91cf6554$var$activeEffect = effect3;
                return fn();
            } finally{
                $eadc12ef91cf6554$var$effectStack.pop();
                $eadc12ef91cf6554$var$resetTracking();
                $eadc12ef91cf6554$var$activeEffect = $eadc12ef91cf6554$var$effectStack[$eadc12ef91cf6554$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $eadc12ef91cf6554$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $eadc12ef91cf6554$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $eadc12ef91cf6554$var$shouldTrack = true;
var $eadc12ef91cf6554$var$trackStack = [];
function $eadc12ef91cf6554$var$pauseTracking() {
    $eadc12ef91cf6554$var$trackStack.push($eadc12ef91cf6554$var$shouldTrack);
    $eadc12ef91cf6554$var$shouldTrack = false;
}
function $eadc12ef91cf6554$var$enableTracking() {
    $eadc12ef91cf6554$var$trackStack.push($eadc12ef91cf6554$var$shouldTrack);
    $eadc12ef91cf6554$var$shouldTrack = true;
}
function $eadc12ef91cf6554$var$resetTracking() {
    const last = $eadc12ef91cf6554$var$trackStack.pop();
    $eadc12ef91cf6554$var$shouldTrack = last === void 0 ? true : last;
}
function $eadc12ef91cf6554$var$track(target, type, key) {
    if (!$eadc12ef91cf6554$var$shouldTrack || $eadc12ef91cf6554$var$activeEffect === void 0) return;
    let depsMap = $eadc12ef91cf6554$var$targetMap.get(target);
    if (!depsMap) $eadc12ef91cf6554$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($eadc12ef91cf6554$var$activeEffect)) {
        dep.add($eadc12ef91cf6554$var$activeEffect);
        $eadc12ef91cf6554$var$activeEffect.deps.push(dep);
        if ($eadc12ef91cf6554$var$activeEffect.options.onTrack) $eadc12ef91cf6554$var$activeEffect.options.onTrack({
            effect: $eadc12ef91cf6554$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $eadc12ef91cf6554$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $eadc12ef91cf6554$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $eadc12ef91cf6554$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $eadc12ef91cf6554$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$eadc12ef91cf6554$var$isArray(target)) {
                    add2(depsMap.get($eadc12ef91cf6554$var$ITERATE_KEY));
                    if ($eadc12ef91cf6554$var$isMap(target)) add2(depsMap.get($eadc12ef91cf6554$var$MAP_KEY_ITERATE_KEY));
                } else if ($eadc12ef91cf6554$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$eadc12ef91cf6554$var$isArray(target)) {
                    add2(depsMap.get($eadc12ef91cf6554$var$ITERATE_KEY));
                    if ($eadc12ef91cf6554$var$isMap(target)) add2(depsMap.get($eadc12ef91cf6554$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($eadc12ef91cf6554$var$isMap(target)) add2(depsMap.get($eadc12ef91cf6554$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $eadc12ef91cf6554$var$isNonTrackableKeys = /* @__PURE__ */ $eadc12ef91cf6554$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $eadc12ef91cf6554$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($eadc12ef91cf6554$var$isSymbol));
var $eadc12ef91cf6554$var$get2 = /* @__PURE__ */ $eadc12ef91cf6554$var$createGetter();
var $eadc12ef91cf6554$var$readonlyGet = /* @__PURE__ */ $eadc12ef91cf6554$var$createGetter(true);
var $eadc12ef91cf6554$var$arrayInstrumentations = /* @__PURE__ */ $eadc12ef91cf6554$var$createArrayInstrumentations();
function $eadc12ef91cf6554$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $eadc12ef91cf6554$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$eadc12ef91cf6554$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($eadc12ef91cf6554$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $eadc12ef91cf6554$var$pauseTracking();
            const res = $eadc12ef91cf6554$var$toRaw(this)[key].apply(this, args);
            $eadc12ef91cf6554$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $eadc12ef91cf6554$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $eadc12ef91cf6554$var$shallowReadonlyMap : $eadc12ef91cf6554$var$readonlyMap : shallow ? $eadc12ef91cf6554$var$shallowReactiveMap : $eadc12ef91cf6554$var$reactiveMap).get(target)) return target;
        const targetIsArray = $eadc12ef91cf6554$var$isArray(target);
        if (!isReadonly && targetIsArray && $eadc12ef91cf6554$var$hasOwn($eadc12ef91cf6554$var$arrayInstrumentations, key)) return Reflect.get($eadc12ef91cf6554$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($eadc12ef91cf6554$var$isSymbol(key) ? $eadc12ef91cf6554$var$builtInSymbols.has(key) : $eadc12ef91cf6554$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $eadc12ef91cf6554$var$track(target, "get", key);
        if (shallow) return res;
        if ($eadc12ef91cf6554$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$eadc12ef91cf6554$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($eadc12ef91cf6554$var$isObject(res)) return isReadonly ? $eadc12ef91cf6554$var$readonly(res) : $eadc12ef91cf6554$var$reactive2(res);
        return res;
    };
}
var $eadc12ef91cf6554$var$set2 = /* @__PURE__ */ $eadc12ef91cf6554$var$createSetter();
function $eadc12ef91cf6554$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $eadc12ef91cf6554$var$toRaw(value);
            oldValue = $eadc12ef91cf6554$var$toRaw(oldValue);
            if (!$eadc12ef91cf6554$var$isArray(target) && $eadc12ef91cf6554$var$isRef(oldValue) && !$eadc12ef91cf6554$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $eadc12ef91cf6554$var$isArray(target) && $eadc12ef91cf6554$var$isIntegerKey(key) ? Number(key) < target.length : $eadc12ef91cf6554$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $eadc12ef91cf6554$var$toRaw(receiver)) {
            if (!hadKey) $eadc12ef91cf6554$var$trigger(target, "add", key, value);
            else if ($eadc12ef91cf6554$var$hasChanged(value, oldValue)) $eadc12ef91cf6554$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $eadc12ef91cf6554$var$deleteProperty(target, key) {
    const hadKey = $eadc12ef91cf6554$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $eadc12ef91cf6554$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $eadc12ef91cf6554$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$eadc12ef91cf6554$var$isSymbol(key) || !$eadc12ef91cf6554$var$builtInSymbols.has(key)) $eadc12ef91cf6554$var$track(target, "has", key);
    return result;
}
function $eadc12ef91cf6554$var$ownKeys(target) {
    $eadc12ef91cf6554$var$track(target, "iterate", $eadc12ef91cf6554$var$isArray(target) ? "length" : $eadc12ef91cf6554$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $eadc12ef91cf6554$var$mutableHandlers = {
    get: $eadc12ef91cf6554$var$get2,
    set: $eadc12ef91cf6554$var$set2,
    deleteProperty: $eadc12ef91cf6554$var$deleteProperty,
    has: $eadc12ef91cf6554$var$has,
    ownKeys: $eadc12ef91cf6554$var$ownKeys
};
var $eadc12ef91cf6554$var$readonlyHandlers = {
    get: $eadc12ef91cf6554$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $eadc12ef91cf6554$var$toReactive = (value)=>$eadc12ef91cf6554$var$isObject(value) ? $eadc12ef91cf6554$var$reactive2(value) : value;
var $eadc12ef91cf6554$var$toReadonly = (value)=>$eadc12ef91cf6554$var$isObject(value) ? $eadc12ef91cf6554$var$readonly(value) : value;
var $eadc12ef91cf6554$var$toShallow = (value)=>value;
var $eadc12ef91cf6554$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $eadc12ef91cf6554$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $eadc12ef91cf6554$var$toRaw(target);
    const rawKey = $eadc12ef91cf6554$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $eadc12ef91cf6554$var$track(rawTarget, "get", key);
    !isReadonly && $eadc12ef91cf6554$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $eadc12ef91cf6554$var$getProto(rawTarget);
    const wrap = isShallow ? $eadc12ef91cf6554$var$toShallow : isReadonly ? $eadc12ef91cf6554$var$toReadonly : $eadc12ef91cf6554$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $eadc12ef91cf6554$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $eadc12ef91cf6554$var$toRaw(target);
    const rawKey = $eadc12ef91cf6554$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $eadc12ef91cf6554$var$track(rawTarget, "has", key);
    !isReadonly && $eadc12ef91cf6554$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $eadc12ef91cf6554$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $eadc12ef91cf6554$var$track($eadc12ef91cf6554$var$toRaw(target), "iterate", $eadc12ef91cf6554$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $eadc12ef91cf6554$var$add(value) {
    value = $eadc12ef91cf6554$var$toRaw(value);
    const target = $eadc12ef91cf6554$var$toRaw(this);
    const proto = $eadc12ef91cf6554$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $eadc12ef91cf6554$var$trigger(target, "add", value, value);
    }
    return this;
}
function $eadc12ef91cf6554$var$set$1(key, value) {
    value = $eadc12ef91cf6554$var$toRaw(value);
    const target = $eadc12ef91cf6554$var$toRaw(this);
    const { has: has2, get: get3 } = $eadc12ef91cf6554$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $eadc12ef91cf6554$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $eadc12ef91cf6554$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $eadc12ef91cf6554$var$trigger(target, "add", key, value);
    else if ($eadc12ef91cf6554$var$hasChanged(value, oldValue)) $eadc12ef91cf6554$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $eadc12ef91cf6554$var$deleteEntry(key) {
    const target = $eadc12ef91cf6554$var$toRaw(this);
    const { has: has2, get: get3 } = $eadc12ef91cf6554$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $eadc12ef91cf6554$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $eadc12ef91cf6554$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $eadc12ef91cf6554$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $eadc12ef91cf6554$var$clear() {
    const target = $eadc12ef91cf6554$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $eadc12ef91cf6554$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $eadc12ef91cf6554$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $eadc12ef91cf6554$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $eadc12ef91cf6554$var$toRaw(target);
        const wrap = isShallow ? $eadc12ef91cf6554$var$toShallow : isReadonly ? $eadc12ef91cf6554$var$toReadonly : $eadc12ef91cf6554$var$toReactive;
        !isReadonly && $eadc12ef91cf6554$var$track(rawTarget, "iterate", $eadc12ef91cf6554$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $eadc12ef91cf6554$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $eadc12ef91cf6554$var$toRaw(target);
        const targetIsMap = $eadc12ef91cf6554$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $eadc12ef91cf6554$var$toShallow : isReadonly ? $eadc12ef91cf6554$var$toReadonly : $eadc12ef91cf6554$var$toReactive;
        !isReadonly && $eadc12ef91cf6554$var$track(rawTarget, "iterate", isKeyOnly ? $eadc12ef91cf6554$var$MAP_KEY_ITERATE_KEY : $eadc12ef91cf6554$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $eadc12ef91cf6554$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$eadc12ef91cf6554$var$capitalize(type)} operation ${key}failed: target is readonly.`, $eadc12ef91cf6554$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $eadc12ef91cf6554$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $eadc12ef91cf6554$var$get$1(this, key);
        },
        get size () {
            return $eadc12ef91cf6554$var$size(this);
        },
        has: $eadc12ef91cf6554$var$has$1,
        add: $eadc12ef91cf6554$var$add,
        set: $eadc12ef91cf6554$var$set$1,
        delete: $eadc12ef91cf6554$var$deleteEntry,
        clear: $eadc12ef91cf6554$var$clear,
        forEach: $eadc12ef91cf6554$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $eadc12ef91cf6554$var$get$1(this, key, false, true);
        },
        get size () {
            return $eadc12ef91cf6554$var$size(this);
        },
        has: $eadc12ef91cf6554$var$has$1,
        add: $eadc12ef91cf6554$var$add,
        set: $eadc12ef91cf6554$var$set$1,
        delete: $eadc12ef91cf6554$var$deleteEntry,
        clear: $eadc12ef91cf6554$var$clear,
        forEach: $eadc12ef91cf6554$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $eadc12ef91cf6554$var$get$1(this, key, true);
        },
        get size () {
            return $eadc12ef91cf6554$var$size(this, true);
        },
        has (key) {
            return $eadc12ef91cf6554$var$has$1.call(this, key, true);
        },
        add: $eadc12ef91cf6554$var$createReadonlyMethod("add"),
        set: $eadc12ef91cf6554$var$createReadonlyMethod("set"),
        delete: $eadc12ef91cf6554$var$createReadonlyMethod("delete"),
        clear: $eadc12ef91cf6554$var$createReadonlyMethod("clear"),
        forEach: $eadc12ef91cf6554$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $eadc12ef91cf6554$var$get$1(this, key, true, true);
        },
        get size () {
            return $eadc12ef91cf6554$var$size(this, true);
        },
        has (key) {
            return $eadc12ef91cf6554$var$has$1.call(this, key, true);
        },
        add: $eadc12ef91cf6554$var$createReadonlyMethod("add"),
        set: $eadc12ef91cf6554$var$createReadonlyMethod("set"),
        delete: $eadc12ef91cf6554$var$createReadonlyMethod("delete"),
        clear: $eadc12ef91cf6554$var$createReadonlyMethod("clear"),
        forEach: $eadc12ef91cf6554$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $eadc12ef91cf6554$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $eadc12ef91cf6554$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $eadc12ef91cf6554$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $eadc12ef91cf6554$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$eadc12ef91cf6554$var$mutableInstrumentations, $eadc12ef91cf6554$var$readonlyInstrumentations, $eadc12ef91cf6554$var$shallowInstrumentations, $eadc12ef91cf6554$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $eadc12ef91cf6554$var$createInstrumentations();
function $eadc12ef91cf6554$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $eadc12ef91cf6554$var$shallowReadonlyInstrumentations : $eadc12ef91cf6554$var$shallowInstrumentations : isReadonly ? $eadc12ef91cf6554$var$readonlyInstrumentations : $eadc12ef91cf6554$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($eadc12ef91cf6554$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $eadc12ef91cf6554$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $eadc12ef91cf6554$var$createInstrumentationGetter(false, false)
};
var $eadc12ef91cf6554$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $eadc12ef91cf6554$var$createInstrumentationGetter(true, false)
};
function $eadc12ef91cf6554$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $eadc12ef91cf6554$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $eadc12ef91cf6554$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $eadc12ef91cf6554$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $eadc12ef91cf6554$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $eadc12ef91cf6554$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $eadc12ef91cf6554$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $eadc12ef91cf6554$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $eadc12ef91cf6554$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $eadc12ef91cf6554$var$targetTypeMap($eadc12ef91cf6554$var$toRawType(value));
}
function $eadc12ef91cf6554$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $eadc12ef91cf6554$var$createReactiveObject(target, false, $eadc12ef91cf6554$var$mutableHandlers, $eadc12ef91cf6554$var$mutableCollectionHandlers, $eadc12ef91cf6554$var$reactiveMap);
}
function $eadc12ef91cf6554$var$readonly(target) {
    return $eadc12ef91cf6554$var$createReactiveObject(target, true, $eadc12ef91cf6554$var$readonlyHandlers, $eadc12ef91cf6554$var$readonlyCollectionHandlers, $eadc12ef91cf6554$var$readonlyMap);
}
function $eadc12ef91cf6554$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$eadc12ef91cf6554$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $eadc12ef91cf6554$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $eadc12ef91cf6554$var$toRaw(observed) {
    return observed && $eadc12ef91cf6554$var$toRaw(observed["__v_raw"]) || observed;
}
function $eadc12ef91cf6554$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$eadc12ef91cf6554$var$magic("nextTick", ()=>$eadc12ef91cf6554$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$eadc12ef91cf6554$var$magic("dispatch", (el)=>$eadc12ef91cf6554$var$dispatch.bind($eadc12ef91cf6554$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$eadc12ef91cf6554$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $eadc12ef91cf6554$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$eadc12ef91cf6554$var$magic("store", $eadc12ef91cf6554$var$getStores);
// packages/alpinejs/src/magics/$data.js
$eadc12ef91cf6554$var$magic("data", (el)=>$eadc12ef91cf6554$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$eadc12ef91cf6554$var$magic("root", (el)=>$eadc12ef91cf6554$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$eadc12ef91cf6554$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $eadc12ef91cf6554$var$mergeProxies($eadc12ef91cf6554$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $eadc12ef91cf6554$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $eadc12ef91cf6554$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $eadc12ef91cf6554$var$globalIdMemo = {};
function $eadc12ef91cf6554$var$findAndIncrementId(name) {
    if (!$eadc12ef91cf6554$var$globalIdMemo[name]) $eadc12ef91cf6554$var$globalIdMemo[name] = 0;
    return ++$eadc12ef91cf6554$var$globalIdMemo[name];
}
function $eadc12ef91cf6554$var$closestIdRoot(el, name) {
    return $eadc12ef91cf6554$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $eadc12ef91cf6554$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $eadc12ef91cf6554$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$eadc12ef91cf6554$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $eadc12ef91cf6554$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $eadc12ef91cf6554$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $eadc12ef91cf6554$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$eadc12ef91cf6554$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $eadc12ef91cf6554$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$eadc12ef91cf6554$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$eadc12ef91cf6554$var$warnMissingPluginMagic("Focus", "focus", "focus");
$eadc12ef91cf6554$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $eadc12ef91cf6554$var$warnMissingPluginMagic(name, magicName, slug) {
    $eadc12ef91cf6554$var$magic(magicName, (el)=>$eadc12ef91cf6554$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$eadc12ef91cf6554$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $eadc12ef91cf6554$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$eadc12ef91cf6554$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $eadc12ef91cf6554$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $eadc12ef91cf6554$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $eadc12ef91cf6554$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $eadc12ef91cf6554$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $eadc12ef91cf6554$var$skipDuringClone(()=>{
            $eadc12ef91cf6554$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $eadc12ef91cf6554$var$getTarget(expression);
        $eadc12ef91cf6554$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$eadc12ef91cf6554$var$mutateDom(()=>{
            clone2.remove();
            $eadc12ef91cf6554$var$destroyTree(clone2);
        }));
});
var $eadc12ef91cf6554$var$teleportContainerDuringClone = document.createElement("div");
function $eadc12ef91cf6554$var$getTarget(expression) {
    let target = $eadc12ef91cf6554$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $eadc12ef91cf6554$var$teleportContainerDuringClone;
    })();
    if (!target) $eadc12ef91cf6554$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $eadc12ef91cf6554$var$handler = ()=>{};
$eadc12ef91cf6554$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$eadc12ef91cf6554$var$directive("ignore", $eadc12ef91cf6554$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$eadc12ef91cf6554$var$directive("effect", $eadc12ef91cf6554$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($eadc12ef91cf6554$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $eadc12ef91cf6554$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $eadc12ef91cf6554$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $eadc12ef91cf6554$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $eadc12ef91cf6554$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $eadc12ef91cf6554$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $eadc12ef91cf6554$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $eadc12ef91cf6554$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (event === "submit") handler4 = wrapHandler(handler4, (next, e)=>{
        if (e.target._x_pendingModelUpdates) e.target._x_pendingModelUpdates.forEach((fn)=>fn());
        next(e);
    });
    if ($eadc12ef91cf6554$var$isKeyEvent(event) || $eadc12ef91cf6554$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($eadc12ef91cf6554$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $eadc12ef91cf6554$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $eadc12ef91cf6554$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $eadc12ef91cf6554$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $eadc12ef91cf6554$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $eadc12ef91cf6554$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $eadc12ef91cf6554$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $eadc12ef91cf6554$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll",
            "blur",
            "change",
            "lazy"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $eadc12ef91cf6554$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $eadc12ef91cf6554$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $eadc12ef91cf6554$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($eadc12ef91cf6554$var$isClickEvent(e.type)) return false;
            if ($eadc12ef91cf6554$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $eadc12ef91cf6554$var$keyToModifiers(key) {
    if (!key) return [];
    key = $eadc12ef91cf6554$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$eadc12ef91cf6554$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $eadc12ef91cf6554$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $eadc12ef91cf6554$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $eadc12ef91cf6554$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $eadc12ef91cf6554$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($eadc12ef91cf6554$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $eadc12ef91cf6554$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let hasChangeModifier = modifiers.includes("change") || modifiers.includes("lazy");
    let hasBlurModifier = modifiers.includes("blur");
    let hasEnterModifier = modifiers.includes("enter");
    let hasExplicitEventModifiers = hasChangeModifier || hasBlurModifier || hasEnterModifier;
    let removeListener;
    if ($eadc12ef91cf6554$var$isCloning) removeListener = ()=>{};
    else if (hasExplicitEventModifiers) {
        let listeners = [];
        let syncValue = (e)=>setValue($eadc12ef91cf6554$var$getInputValue(el, modifiers, e, getValue()));
        if (hasChangeModifier) listeners.push($eadc12ef91cf6554$var$on(el, "change", modifiers, syncValue));
        if (hasBlurModifier) {
            listeners.push($eadc12ef91cf6554$var$on(el, "blur", modifiers, syncValue));
            if (el.form) {
                let syncCallback = ()=>syncValue({
                        target: el
                    });
                if (!el.form._x_pendingModelUpdates) el.form._x_pendingModelUpdates = [];
                el.form._x_pendingModelUpdates.push(syncCallback);
                cleanup2(()=>el.form._x_pendingModelUpdates.splice(el.form._x_pendingModelUpdates.indexOf(syncCallback), 1));
            }
        }
        if (hasEnterModifier) listeners.push($eadc12ef91cf6554$var$on(el, "keydown", modifiers, (e)=>{
            if (e.key === "Enter") syncValue(e);
        }));
        removeListener = ()=>listeners.forEach((remove)=>remove());
    } else {
        let event = el.tagName.toLowerCase() === "select" || [
            "checkbox",
            "radio"
        ].includes(el.type) ? "change" : "input";
        removeListener = $eadc12ef91cf6554$var$on(el, event, modifiers, (e)=>{
            setValue($eadc12ef91cf6554$var$getInputValue(el, modifiers, e, getValue()));
        });
    }
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $eadc12ef91cf6554$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($eadc12ef91cf6554$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $eadc12ef91cf6554$var$on(el.form, "reset", [], (e)=>{
            $eadc12ef91cf6554$var$nextTick(()=>el._x_model && el._x_model.set($eadc12ef91cf6554$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $eadc12ef91cf6554$var$mutateDom(()=>$eadc12ef91cf6554$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $eadc12ef91cf6554$var$getInputValue(el, modifiers, event, currentValue) {
    return $eadc12ef91cf6554$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($eadc12ef91cf6554$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $eadc12ef91cf6554$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $eadc12ef91cf6554$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$eadc12ef91cf6554$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $eadc12ef91cf6554$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $eadc12ef91cf6554$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($eadc12ef91cf6554$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $eadc12ef91cf6554$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $eadc12ef91cf6554$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $eadc12ef91cf6554$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $eadc12ef91cf6554$var$isNumeric2(number) ? number : rawValue;
}
function $eadc12ef91cf6554$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $eadc12ef91cf6554$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $eadc12ef91cf6554$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$eadc12ef91cf6554$var$directive("cloak", (el)=>queueMicrotask(()=>$eadc12ef91cf6554$var$mutateDom(()=>el.removeAttribute($eadc12ef91cf6554$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$eadc12ef91cf6554$var$addInitSelector(()=>`[${$eadc12ef91cf6554$var$prefix("init")}]`);
$eadc12ef91cf6554$var$directive("init", $eadc12ef91cf6554$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$eadc12ef91cf6554$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $eadc12ef91cf6554$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$eadc12ef91cf6554$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $eadc12ef91cf6554$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $eadc12ef91cf6554$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$eadc12ef91cf6554$var$mapAttributes($eadc12ef91cf6554$var$startingWith(":", $eadc12ef91cf6554$var$into($eadc12ef91cf6554$var$prefix("bind:"))));
var $eadc12ef91cf6554$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $eadc12ef91cf6554$var$injectBindingProviders(bindingProviders);
        let getBindings = $eadc12ef91cf6554$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $eadc12ef91cf6554$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $eadc12ef91cf6554$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $eadc12ef91cf6554$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $eadc12ef91cf6554$var$mutateDom(()=>$eadc12ef91cf6554$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$eadc12ef91cf6554$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$eadc12ef91cf6554$var$directive("bind", $eadc12ef91cf6554$var$handler2);
function $eadc12ef91cf6554$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$eadc12ef91cf6554$var$addRootSelector(()=>`[${$eadc12ef91cf6554$var$prefix("data")}]`);
$eadc12ef91cf6554$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($eadc12ef91cf6554$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $eadc12ef91cf6554$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $eadc12ef91cf6554$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $eadc12ef91cf6554$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $eadc12ef91cf6554$var$injectMagics(data2, el);
    let reactiveData = $eadc12ef91cf6554$var$reactive(data2);
    $eadc12ef91cf6554$var$initInterceptors(reactiveData);
    let undo = $eadc12ef91cf6554$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $eadc12ef91cf6554$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $eadc12ef91cf6554$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$eadc12ef91cf6554$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $eadc12ef91cf6554$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$eadc12ef91cf6554$var$isCloning) return false;
    if ($eadc12ef91cf6554$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$eadc12ef91cf6554$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $eadc12ef91cf6554$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $eadc12ef91cf6554$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $eadc12ef91cf6554$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $eadc12ef91cf6554$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$eadc12ef91cf6554$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $eadc12ef91cf6554$var$parseForExpression(expression);
    let evaluateItems = $eadc12ef91cf6554$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $eadc12ef91cf6554$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$eadc12ef91cf6554$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$eadc12ef91cf6554$var$mutateDom(()=>{
                $eadc12ef91cf6554$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $eadc12ef91cf6554$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($eadc12ef91cf6554$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $eadc12ef91cf6554$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $eadc12ef91cf6554$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $eadc12ef91cf6554$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $eadc12ef91cf6554$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $eadc12ef91cf6554$var$mutateDom(()=>{
                $eadc12ef91cf6554$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $eadc12ef91cf6554$var$mutateDom(()=>{
                if (!elForSpot) $eadc12ef91cf6554$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $eadc12ef91cf6554$var$reactive(scope2);
            $eadc12ef91cf6554$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $eadc12ef91cf6554$var$mutateDom(()=>{
                lastEl.after(clone2);
                $eadc12ef91cf6554$var$skipDuringClone(()=>$eadc12ef91cf6554$var$initTree(clone2))();
            });
            if (typeof key === "object") $eadc12ef91cf6554$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $eadc12ef91cf6554$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $eadc12ef91cf6554$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $eadc12ef91cf6554$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $eadc12ef91cf6554$var$handler3() {}
$eadc12ef91cf6554$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $eadc12ef91cf6554$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$eadc12ef91cf6554$var$directive("ref", $eadc12ef91cf6554$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$eadc12ef91cf6554$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $eadc12ef91cf6554$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $eadc12ef91cf6554$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $eadc12ef91cf6554$var$addScopeToNode(clone2, {}, el);
        $eadc12ef91cf6554$var$mutateDom(()=>{
            el.after(clone2);
            $eadc12ef91cf6554$var$skipDuringClone(()=>$eadc12ef91cf6554$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $eadc12ef91cf6554$var$mutateDom(()=>{
                $eadc12ef91cf6554$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$eadc12ef91cf6554$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$eadc12ef91cf6554$var$setIdRoot(el, name));
});
$eadc12ef91cf6554$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$eadc12ef91cf6554$var$mapAttributes($eadc12ef91cf6554$var$startingWith("@", $eadc12ef91cf6554$var$into($eadc12ef91cf6554$var$prefix("on:"))));
$eadc12ef91cf6554$var$directive("on", $eadc12ef91cf6554$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $eadc12ef91cf6554$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $eadc12ef91cf6554$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$eadc12ef91cf6554$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$eadc12ef91cf6554$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$eadc12ef91cf6554$var$warnMissingPluginDirective("Focus", "trap", "focus");
$eadc12ef91cf6554$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $eadc12ef91cf6554$var$warnMissingPluginDirective(name, directiveName, slug) {
    $eadc12ef91cf6554$var$directive(directiveName, (el)=>$eadc12ef91cf6554$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$eadc12ef91cf6554$var$alpine_default.setEvaluator($eadc12ef91cf6554$var$normalEvaluator);
$eadc12ef91cf6554$var$alpine_default.setRawEvaluator($eadc12ef91cf6554$var$normalRawEvaluator);
$eadc12ef91cf6554$var$alpine_default.setReactivityEngine({
    reactive: $eadc12ef91cf6554$var$reactive2,
    effect: $eadc12ef91cf6554$var$effect2,
    release: $eadc12ef91cf6554$var$stop,
    raw: $eadc12ef91cf6554$var$toRaw
});
var $eadc12ef91cf6554$export$b7ee041e4ad2afec = $eadc12ef91cf6554$var$alpine_default;
// packages/alpinejs/builds/module.js
var $eadc12ef91cf6554$export$2e2bcd8739ae039 = $eadc12ef91cf6554$export$b7ee041e4ad2afec;


/**
 * Creates the store for the appearance (light / dark theme).
 *
 * @param {import('alpinejs').Alpine} Alpine The alpine instance.
 */ function $486443c7616006a1$export$2e2bcd8739ae039(Alpine) {
    Alpine.store("appearance", {
        theme: Alpine.$persist("system").as("theme"),
        get resolved () {
            if (this.theme === "system") return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
            return this.theme;
        },
        toggle () {
            this.theme = this.resolved === "dark" ? "light" : "dark";
        },
        init () {
            Alpine.effect(()=>{
                const root = document.documentElement;
                root.setAttribute("data-no-transition", "");
                root.setAttribute("data-theme", this.theme);
                setTimeout(()=>root.removeAttribute("data-no-transition"));
            });
        }
    });
}


/**
 * Provides the theme switcher menu component data.
 * @param {import("alpinejs").Alpine} Alpine The Alpine instance.
 */ function $d6abbe935e7f2ac1$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("themeSwitcher", ()=>({
            open: false,
            focusedIdx: 0,
            themes: [],
            openMenu () {
                this.open = true;
                this.focusOnNextTick(this.themes.indexOf(this.$store.appearance.theme));
            },
            closeMenu ({ restoreFocus: restoreFocus = true } = {}) {
                this.open = false;
                restoreFocus && this.$refs.trigger.focus();
            },
            onFocusOut (event) {
                if (this.open && !this.$refs.menu.contains(event.relatedTarget)) this.$nextTick(()=>this.closeMenu({
                        restoreFocus: false
                    }));
            },
            focusNext () {
                this.focusOnNextTick((this.focusedIdx + 1) % this.themes.length);
            },
            focusPrevious () {
                const { length: length } = this.themes;
                this.focusOnNextTick((this.focusedIdx - 1 + length) % length);
            },
            selectTheme (theme, { keepOpen: keepOpen = false } = {}) {
                this.$store.appearance.theme = theme;
                !keepOpen && this.closeMenu();
            },
            focusOnNextTick (index) {
                this.focusedIdx = index;
                this.$nextTick(()=>{
                    this.$refs.menu.querySelector('[data-focused="true"]')?.focus();
                });
            }
        }));
}


const $6e0739daa36feaff$var$baseUrl = document.currentScript?.getAttribute("data-base") ?? "/";
const $6e0739daa36feaff$var$indexJsonUrl = $6e0739daa36feaff$var$baseUrl + "index.json";
function $6e0739daa36feaff$export$2e2bcd8739ae039(Alpine) {
    Alpine.store("bookmarks", {
        /**
     * The index of all notes.
     * A key-value map of note URLs to note titles.
     * @type {Record<string, string>}
     */ index: {},
        /**
     * The list of bookmarked notes.
     * @type {string[]}
     */ items: Alpine.$persist([]).as("favorites"),
        async init () {
            this.index = await fetch($6e0739daa36feaff$var$indexJsonUrl).then((r)=>r.json()).catch(()=>{
                console.error("Could not fetch notes index");
                return {};
            });
            this.cleanUpBookmarks();
        },
        is (id) {
            return this.items.includes(id);
        },
        /**
     * Toggles the bookmark status of a note.
     * @param {string} id
     */ toggle (id) {
            if (this.items.includes(id)) this.items = this.items.filter((bkm)=>bkm !== id);
            else this.items.push(id);
        },
        cleanUpBookmarks () {
            if (Object.keys(this.index).length === 0) return;
            this.items = this.items.filter((id)=>!!this.index[id]);
        }
    });
}


/**
 * Creates the store for the collapsible sidebar.
 *
 * @param {import('alpinejs').Alpine} Alpine The alpine instance.
 */ function $b2c6212f50705efc$export$2e2bcd8739ae039(Alpine) {
    Alpine.store("nav", {
        open: false,
        toggle (value) {
            this.open = value ?? !this.open;
            if (this.open) Alpine.store("panel").toggle(false);
        }
    });
}


/**
 * Provides the store for the panel overlay on mobile.
 *
 * @param {import("alpinejs").Alpine} Alpine The Alpine instance.
 */ function $1c78ced2baffef02$export$2e2bcd8739ae039(Alpine) {
    Alpine.store("panel", {
        withOverlay: false,
        open: false,
        panelRef: null,
        overlayPanelRef: null,
        init () {
            this.panelRef = document.querySelector("[data-ref=panel]");
            this.overlayPanelRef = document.querySelector("[data-ref=overlayPanel]");
            if (!this.panelRef || !this.overlayPanelRef) return;
            $1c78ced2baffef02$var$observeMediaQuery("(min-width: 64em)", (matches)=>{
                this.withOverlay = !matches;
                this.open = false;
                const source = this.withOverlay ? this.panelRef : this.overlayPanelRef;
                const target = this.withOverlay ? this.overlayPanelRef : this.panelRef;
                if (source.firstElementChild) target.append(source.firstElementChild);
            });
        },
        onOverlayClick (event) {
            const isSelf = event.target === event.currentTarget;
            const isSameTabLink = event.target.tagName === "A" && event.target.getAttribute("target") !== "_blank";
            this.toggle(!(isSelf || isSameTabLink));
        },
        toggle (value) {
            this.open = value ?? !this.open;
            if (this.open) Alpine.store("nav").toggle(false);
        }
    });
}
function $1c78ced2baffef02$var$observeMediaQuery(query, callback) {
    const mediaQuery = window.matchMedia(query);
    const handle = ()=>callback(mediaQuery.matches);
    mediaQuery.addEventListener("change", handle);
    handle();
    return ()=>mediaQuery.removeEventListener("change", handle);
}



var $gNVT3 = parcelRequire("gNVT3");
/**
 * Creates the collapsible data for collapsing sections.
 * @param {import("alpinejs").Alpine} Alpine The alpine instance.
 */ function $c059e509ce4b668c$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("collapsible", (key, defaultExpanded)=>({
            expanded: Alpine.$persist(defaultExpanded).as(`collapsible:${key}`).using(sessionStorage),
            init () {
                if (this.$el.querySelector("[aria-current=page]")) this.expanded = true;
            },
            toggle () {
                this.expanded = !this.expanded;
            }
        }));
}


const $87a8c1cd8668e939$var$tags = new Set([
    "INPUT",
    "TEXTAREA",
    "SELECT"
]);
function $87a8c1cd8668e939$export$2e2bcd8739ae039(Alpine) {
    Alpine.store("hotkeys", {
        async register (shortcut, callback) {
            document.addEventListener("keydown", (event)=>{
                if (event.defaultPrevented) return;
                if (event.key !== shortcut || event.metaKey || event.ctrlKey) return;
                if ($87a8c1cd8668e939$var$tags.has(document.activeElement?.tagName)) return;
                event.preventDefault();
                callback();
            });
        }
    });
}


/**
 * Register the scroll container data object.
 *
 * @param {import("alpinejs").Alpine} Alpine The alpine instance.
 */ function $8c8d05abf0a572bd$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("scrollContainer", (identifier)=>({
            key: `scroll-position:${identifier}`,
            init () {
                const value = sessionStorage.getItem(this.key);
                setTimeout(()=>this.$el.scrollTop = parseInt(value, 10));
            },
            container: {
                ["@scroll.debounce"] (event) {
                    sessionStorage.setItem(this.key, event.target.scrollTop);
                }
            }
        }));
}


/**
 * Registers the WindowScroll object for x-bind.
 *
 * @param {import("alpinejs").Alpine} Alpine The Alpine instance.
 */ function $fa1f916516ec3fa0$export$2e2bcd8739ae039(Alpine) {
    Alpine.bind("WindowScroll", ()=>({
            ["@scroll.window"] () {
                this.$el.setAttribute("data-scrolled", window.document.documentElement.scrollTop > 0);
            }
        }));
}


/**
 * Alpine Persist plugin but with error handling.
 * See https://github.com/alpinejs/alpine/blob/main/packages/persist/src/index.js
 *
 * @param {import("alpinejs").Alpine} Alpine The alpine instance.
 */ function $ae386868e5cb82ab$export$2e2bcd8739ae039(Alpine) {
    let persist = ()=>{
        let alias;
        let storage = localStorage;
        return Alpine.interceptor((initialValue, getter, setter, path, key)=>{
            let lookup = alias || `_x_${path}`;
            let initial = $ae386868e5cb82ab$var$storageHas(lookup, storage) ? $ae386868e5cb82ab$var$storageGet(lookup, storage) : initialValue;
            setter(initial);
            Alpine.effect(()=>{
                let value = getter();
                $ae386868e5cb82ab$var$storageSet(lookup, value, storage);
                setter(value);
            });
            return initial;
        }, (func)=>{
            func.as = (key)=>{
                alias = key;
                return func;
            }, func.using = (target)=>{
                storage = target;
                return func;
            };
        });
    };
    Object.defineProperty(Alpine, "$persist", {
        get: ()=>persist()
    });
    Alpine.magic("persist", persist);
    Alpine.persist = (key, { get: get, set: set }, storage = localStorage)=>{
        let initial = $ae386868e5cb82ab$var$storageHas(key, storage) ? $ae386868e5cb82ab$var$storageGet(key, storage) : get();
        set(initial);
        Alpine.effect(()=>{
            let value = get();
            $ae386868e5cb82ab$var$storageSet(key, value, storage);
            set(value);
        });
    };
}
function $ae386868e5cb82ab$var$storageHas(key, storage) {
    const item = storage.getItem(key);
    const isValid = item !== null && $ae386868e5cb82ab$var$canParse(item);
    return isValid;
}
function $ae386868e5cb82ab$var$storageGet(key, storage) {
    return JSON.parse(storage.getItem(key, storage));
}
function $ae386868e5cb82ab$var$storageSet(key, value, storage) {
    storage.setItem(key, JSON.stringify(value));
}
function $ae386868e5cb82ab$var$canParse(value) {
    try {
        JSON.parse(value);
        return true;
    } catch (e) {
        return false;
    }
}


/**
 * Provides a data object to copy text to the clipboard.
 *
 * @param {import("alpinejs").Alpine} Alpine The Alpine instance.
 */ function $33cd3bb9b17d0b53$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("copyToClipboard", ()=>({
            copied: false,
            copyBtn: {
                ":data-copied" () {
                    return `${this.copied}`;
                },
                async ["@click"] () {
                    const text = this.$el.previousElementSibling.innerText;
                    await navigator.clipboard.writeText(text);
                    this.copied = true;
                    setTimeout(()=>this.copied = false, 1500);
                }
            }
        }));
}


/**
 * Copies a page's markdown copy to the clipboard.
 *
 * The text arrives from the network, and Safari only lets a clipboard write
 * begin inside the click that asked for it. A ClipboardItem accepts the
 * pending text as a promise, so the write starts at once and completes when
 * the fetch does.
 *
 * @param {import("alpinejs").Alpine} Alpine The Alpine instance.
 */ function $b12f776a205c5cb4$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("copyMarkdown", (path)=>({
            copied: false,
            button: {
                async ["@click"] () {
                    const text = fetch(path).then((response)=>{
                        if (!response.ok) throw new Error(`${path} answered ${response.status}`);
                        return response.text();
                    }).then((markdown)=>new Blob([
                            markdown
                        ], {
                            type: "text/plain"
                        }));
                    await navigator.clipboard.write([
                        new ClipboardItem({
                            "text/plain": text
                        })
                    ]);
                    this.copied = true;
                    setTimeout(()=>this.copied = false, 1500);
                }
            }
        }));
}


/**
 * Creates the data for the table of contents.
 *
 * @param {import('alpinejs').Alpine} Alpine The alpine instance.
 */ function $6d9a4f9d9a3bd53f$export$2e2bcd8739ae039(Alpine) {
    Alpine.data("toc", ()=>({
            activeId: null,
            indicator: {
                start: 0,
                size: 0
            },
            _links: undefined,
            _headings: undefined,
            _nextHash: window.location.hash.slice(1),
            _scrollTimer: 0,
            _resizeObserver: null,
            get indicatorStyles () {
                return {
                    "--toc-indicator-start": `${this.indicator.start}px`,
                    "--toc-indicator-size": `${this.indicator.size}px`
                };
            },
            init () {
                this._links = [
                    ...this.$el.querySelectorAll("a")
                ];
                this._headings = this._links.map((link)=>link.getAttribute("href").slice(1)).map((id)=>document.getElementById(id));
                // Initialize trigger in case the user loads the page for the first time
                // without a restored scroll position or hash.
                this.onScroll(false);
                // Ensure indicator is updated when mobile panel is opened
                this._resizeObserver = new ResizeObserver(()=>this._calcIndicator());
                this._resizeObserver.observe(this.$el);
            },
            destroy () {
                this._resizeObserver?.disconnect();
            },
            onNavigate (id) {
                // Hash will be used the next time a scroll event is triggered.
                this._nextHash = id;
                // If the hash target is already at the correct position,
                // or scrolling to the target is not possible (e.g. the target is at the bottom of the page
                // and the user is already at the bottom), we trigger the scroll event manually.
                // The timer will be canceled if onScroll() is called by the scroll event.
                this._scrollTimer = window.setTimeout(()=>this.onScroll(true), 50);
            },
            onScroll (throttled = true) {
                window.clearTimeout(this._scrollTimer);
                if (throttled) // We throttle the onScroll event for better performance (via AlpineJS).
                // The last few scroll events will be ignored because of that,
                // resulting in a incorrect position calculation.
                // => Trigger a recalculation with a short delay to fix this.
                this._scrollTimer = window.setTimeout(()=>this.onScroll(false), 60);
                this._calcPosition();
                this._calcIndicator();
            },
            _calcPosition () {
                const topOffset = this._calcTopOffset();
                const headings = this._headings.map((heading)=>{
                    const { top: top, height: height } = heading.getBoundingClientRect();
                    // We activate the heading a bit before it reaches the top.
                    // There is no scientific reason for this value. 🤷‍♂️
                    const allowedArea = topOffset + 2 * height;
                    return {
                        id: heading.id,
                        pos: top,
                        isInFocusAreaOrAbove: top <= allowedArea
                    };
                });
                // If a valid next hash is available, we use it instead of the scroll position
                // because for headings at the bottom of the page, the scroll position is not correct.
                const ids = headings.map((x)=>x.id);
                const idFromNextHash = this._getValidIdFromNextHash(ids);
                if (idFromNextHash) {
                    this.activeId = idFromNextHash;
                    this._nextHash = undefined;
                    // Scrolling to a hash target happens sychronously (we don't use smooth scrolling).
                    // Therefore we don't need to trigger a debounced scroll event,
                    // which would overwrite the position.
                    window.clearTimeout(this._scrollTimer);
                    return;
                }
                // If the user is at the bottom of the page and the page ends
                // with short chapters, the last (few) heading(s) might never be activated.
                // which feels wrong (but many websites have this issue).
                // To fix this, we mark the last heading as active if the user is at the bottom.
                // As a result, the indicator may "jump" a bit when scrolling around
                // which isn't ideal but probably better than the other issue (who knows).
                // We only do this if the page is scrollable, because for short pages
                // that are not scrollable we shouldn't mark the last heading as active.
                const pos = window.scrollY > 0 ? window.innerHeight + window.scrollY : 0;
                const scrollOffset = 10; // Just some random value that feels right.
                const isNearBottom = pos >= document.body.offsetHeight - scrollOffset;
                if (isNearBottom) {
                    this.activeId = headings.at(-1)?.id;
                    return;
                }
                // Now we find the last heading that is not below the focus area
                this.activeId = headings.filter((x)=>x.isInFocusAreaOrAbove).sort((a, b)=>b.pos - a.pos).at(0)?.id ?? null;
            },
            _getValidIdFromNextHash (validIds) {
                const isValid = !!this._nextHash && validIds.includes(this._nextHash) && // Reloading the page with a hash will not focus the heading
                // and restore the scroll position (tested in Brave). In this case,
                // we should not use the hash.
                document.activeElement?.id === this._nextHash;
                return isValid ? this._nextHash : null;
            },
            _calcIndicator () {
                const activeHref = `#${this.activeId}`;
                const activeLink = this.activeId ? this._links.find((x)=>x.getAttribute("href") == activeHref) : undefined;
                if (!activeLink) {
                    this.indicator = {
                        start: 0,
                        size: 0
                    };
                    return;
                }
                const rootElRect = activeLink.closest("ul").getBoundingClientRect();
                const linkRect = activeLink.getBoundingClientRect();
                this.indicator = {
                    start: linkRect.y - rootElRect.y,
                    size: linkRect.height
                };
            },
            _calcTopOffset () {
                // The headings have a scroll margin because of the sticky header.
                // All headings should have the same scroll margin, so it should be fine
                // to use the first heading's scroll margin.
                const style = this._headings.length ? window.getComputedStyle(this._headings[0]) : undefined;
                return style ? parseInt(style.scrollMarginBlockStart, 10) : 0;
            }
        }));
}


(0, $eadc12ef91cf6554$export$2e2bcd8739ae039).plugin((0, $ae386868e5cb82ab$export$2e2bcd8739ae039));
(0, $486443c7616006a1$export$2e2bcd8739ae039)((0, $eadc12ef91cf6554$export$2e2bcd8739ae039));
(0, $d6abbe935e7f2ac1$export$2e2bcd8739ae039)((0, $eadc12ef91cf6554$export$2e2bcd8739ae039));
(0, $6e0739daa36feaff$export$2e2bcd8739ae039)((0, $eadc12ef91cf6554$export$2e2bcd8739ae039));
(0, $b2c6212f50705efc$export$2e2bcd8739ae039)((0, $eadc12ef91cf6554$export$2e2bcd8739ae039));
(0, $1c78ced2baffef02$export$2e2bcd8739ae039)((0, $eadc12ef91cf6554$export$2e2bcd8739ae039));
(0, $gNVT3.default)((0, $eadc12ef91cf6554$export$2e2bcd8739ae039));
(0, $c059e509ce4b668c$export$2e2bcd8739ae039)((0, $eadc12ef91cf6554$export$2e2bcd8739ae039));
(0, $87a8c1cd8668e939$export$2e2bcd8739ae039)((0, $eadc12ef91cf6554$export$2e2bcd8739ae039));
(0, $8c8d05abf0a572bd$export$2e2bcd8739ae039)((0, $eadc12ef91cf6554$export$2e2bcd8739ae039));
(0, $fa1f916516ec3fa0$export$2e2bcd8739ae039)((0, $eadc12ef91cf6554$export$2e2bcd8739ae039));
(0, $33cd3bb9b17d0b53$export$2e2bcd8739ae039)((0, $eadc12ef91cf6554$export$2e2bcd8739ae039));
(0, $b12f776a205c5cb4$export$2e2bcd8739ae039)((0, $eadc12ef91cf6554$export$2e2bcd8739ae039));
(0, $6d9a4f9d9a3bd53f$export$2e2bcd8739ae039)((0, $eadc12ef91cf6554$export$2e2bcd8739ae039));
(0, $eadc12ef91cf6554$export$2e2bcd8739ae039).start();

})();
//# sourceMappingURL=app.js.map
